import { usingGet } from '@ocean/api'

export const getTestScheduleDetails = (scheduleId: string) =>
  usingGet(`MarlinsEnglishTests/schedule?id=${scheduleId}`, { useProxy: true })
